<h2 mat-dialog-title>Run Production</h2>
<mat-dialog-content class="container">
  <mat-checkbox [(ngModel)]="notifyUser">Send Notification Upon Completion</mat-checkbox>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" (click)="run()">Run</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
